import LaunchIcon from '@mui/icons-material/Launch';
import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Row from 'blocks/Row';
import { PageTitle, Text } from 'blocks/Text';
import EmptyBox from 'components/EmptyBox';
import { TextField } from 'components/Form';
import Pager from 'components/Pager';
import Table from 'components/Table';
import FlightDetailTransferModal from 'components/modals/FlightTransferDetailModal';
import FreeTicketDetailTransactionModal from 'components/modals/FreeTicketTransferDetailModal';
import TransferDetailTransactionModal from 'components/modals/TransferTransactionDetailModal';
import { getDate } from 'helper/date';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import urls from 'utils/urls';
import { TransactionInterface } from '../View/viwe.interface';
import ModalSearch from '../components/ModalSearch';
import * as S from './viwe.styles';
const ViewMiles = () => {
  const { t } = useTranslation();
  const flightDetailModal = useRef<any>();
  const freeTicketDetailModal = useRef<any>();
  const transferDetailModal = useRef<any>();
  const [transactions, setTransactions] = useState<any[]>([]);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });

  useEffect(() => {
    getTransactions(pageData.page);
  }, [pageData.page]);

  const showFlightDetail = async (transaction: TransactionInterface) => {
    const res = await axios.get(urls.transaction + '/' + transaction.id);

    const data = res.data.response;
    if (data.entity.toLowerCase() === 'flight') {
      flightDetailModal.current.openModal(data.flight);
    } else if (data.entity.toLowerCase() === 'freeticket') {
      freeTicketDetailModal.current.openModal(data.freeTicket);
    } else if (data.entity.toLowerCase() === 'transfer') {
      transferDetailModal.current.openModal(data.transfer);
    }
  };

  const getTransactions = async (page, query?: string) => {
    let params = `?page=${page}` + (query || '');

    const res = await axios.get(urls.transaction + params);

    setTransactions(res.data.response.data);
    setPageData({
      totalPage: res.data.response.totalPages,
      page: res.data.response.currentPage,
      count: res.data.response.totalItems,
    });
  };

  const next = (): void => setPageData({ ...pageData, page: pageData.page + 1 });

  const prev = (): void => {
    if (pageData.page === 0) return;

    setPageData({ ...pageData, page: pageData.page - 1 });
  };

  return (
    <WithSidebar>
      <S.Wrapper>
        <BoxWrapper>
          <S.PageTitle as={Row} justify="space-between" align="center">
            <PageTitle>{t('pages.miles.view.title')}</PageTitle>

            <S.ParentSearch>
              <TextField
                placeholder={t('pages.miles.view.sections.filters.fields.search.placeholder')}
                readonly
                onClick={() => setOpenModalSearch(true)}
              />
            </S.ParentSearch>
          </S.PageTitle>
        </BoxWrapper>

        {transactions.length ? (
          <>
            <S.ParentTable>
              <Table
                name="transaction"
                head={[
                  { text: t('pages.miles.view.sections.tables.transaction.headers.activity') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.rewardMiles') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.tierMiles') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.expirationDate') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.date') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.description') },
                  { text: t('pages.miles.view.sections.tables.transaction.headers.description') },
                ]}
                rows={transactions.map((transaction) => [
                  { content: transaction.activity },
                  {
                    content: (
                      <Text
                        size="small"
                        color={transaction.rewardMilageUsed.toString().includes('-') ? 'error' : 'success'}
                      >
                        {transaction.rewardMilageUsed}
                      </Text>
                    ),
                  },
                  {
                    content: (
                      <Text size="small" color="info">
                        {transaction.tierMilageUsed}
                      </Text>
                    ),
                  },
                  { content: getDate(transaction.tierValidity) },
                  { content: getDate(transaction.createdAt) },
                  { content: transaction.description },

                  {
                    content:
                      transaction.entity &&
                      ['flight', 'freeticket', 'transfer'].includes(transaction.entity.toLowerCase()) ? (
                        <Button
                          color="text-button"
                          iconStart={<LaunchIcon />}
                          styleType="text-button"
                          onClick={() => showFlightDetail(transaction)}
                          size={'large'}
                        />
                      ) : (
                        ''
                      ),
                    className: 'action-table',
                  },
                ])}
              />
            </S.ParentTable>

            <Pager total={pageData.count} page={pageData.page} next={next} prev={prev} />
          </>
        ) : (
          <EmptyBox boxed title={t('pages.miles.view.sections.tables.transaction.emptyText')} />
        )}
      </S.Wrapper>
      <FlightDetailTransferModal ref={flightDetailModal} />
      <FreeTicketDetailTransactionModal ref={freeTicketDetailModal} />
      <TransferDetailTransactionModal ref={transferDetailModal} />
      <ModalSearch
        open={openModalSearch}
        onClose={() => setOpenModalSearch(false)}
        onSearch={(params: string) => getTransactions(0, params)}
        onClearFilter={() => getTransactions(0)}
      />
    </WithSidebar>
  );
};

export default ViewMiles;
